import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";
import QuickStockCard from "../../../components/Stock/QuickStockCard";
import QuickStockModal from "../../../components/Stock/QuickStockModal";

class StockItemDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            isLoad:true,
            parentCategories: [],
            subCategories: [],
            selectedParentId: '',
            warehouseStocks: [],
            warehouses: [],
            stockItem: null,
            isQuickStockModalOpen: false,
            quickStockMovementType: 'purchase',
            formData : {
                name:'',
                sku:'',
                barcode:'',
                category_id:'',
                unit:'adet',
                description:'',
                min_stock_level:'0',
                max_stock_level:'',
                unit_price:'0',
                is_serialized: false,
                is_lot_tracked: false,
                is_active: true
            }
        }
    }

    async componentDidMount() {
        // Paralel olarak ana kategorileri, depo stoklarını ve depoları getir
        const parallelPromises = [
            this.fetchParentCategories(),
            this.fetchWarehouseStocks(),
            this.fetchWarehouses()
        ];

        // Item detayını getir
        await this.fetchStockItemDetail();

        // Paralel isteklerin bitmesini bekle
        await Promise.all(parallelPromises);

        // Tüm veriler yüklendi
        this.setState({isLoad: false});
    }

    fetchParentCategories = async () => {
        try {
            const response = await apiCall('business/stock/category/all?parent_only=true','get');
            this.setState({parentCategories: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchSubCategories = async (parentId) => {
        if(!parentId) {
            this.setState({subCategories: [], selectedParentId: ''});
            return;
        }

        try {
            const response = await apiCall(`business/stock/category/all?parent_id=${parentId}`,'get');
            this.setState({
                subCategories: response.data || [],
                selectedParentId: parentId
            });
        } catch (e) {
            console.error(e);
            this.setState({subCategories: []});
        }
    }

    fetchStockItemDetail = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/item/info/${id}`,'get');
            if(response.status === 'success') {
                const itemData = response.data;

                this.setState({
                    stockItem: itemData, // Stok item'ı state'e kaydet
                    formData: {
                        name: itemData.name || '',
                        sku: itemData.sku || '',
                        barcode: itemData.barcode || '',
                        category_id: itemData.category_id || '',
                        unit: itemData.unit || 'adet',
                        description: itemData.description || '',
                        min_stock_level: itemData.min_stock_level || '0',
                        max_stock_level: itemData.max_stock_level || '',
                        unit_price: itemData.unit_price || '0',
                        is_serialized: itemData.is_serialized || false,
                        is_lot_tracked: itemData.is_lot_tracked || false,
                        is_active: itemData.is_active !== undefined ? itemData.is_active : true
                    }
                });

                // Eğer kategori varsa, parent kategorisini bul ve alt kategorileri getir
                if(itemData.category_id && itemData.category) {
                    const parentId = itemData.category.parent_id;
                    if(parentId) {
                        // Parent ID'yi set et ve alt kategorileri yükle
                        this.setState({ selectedParentId: parentId });
                        await this.fetchSubCategories(parentId);
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    handleParentCategoryChange = (e) => {
        const parentId = e.target.value;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                category_id: '' // Alt kategori seçimi sıfırla
            }
        }));
        this.fetchSubCategories(parentId);
    }

    fetchWarehouseStocks = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/item/warehouse-stock/${id}`,'get');
            if(response.status === 'success') {
                this.setState({warehouseStocks: response.data || []});
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (e) => {
        const {id,value,type,checked} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : type === 'checkbox' ? checked : value
            }
        }))
    }

    openQuickStockModal = (movementType) => {
        this.setState({
            isQuickStockModalOpen: true,
            quickStockMovementType: movementType
        });
    };

    closeQuickStockModal = () => {
        this.setState({isQuickStockModalOpen: false});
    };

    handleQuickStockSuccess = () => {
        // Stok bilgilerini yeniden yükle
        this.fetchWarehouseStocks();
        this.fetchStockItemDetail();
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const {id} = this.props.match.params;
        const stockItemFormData = new FormData();

        Object.keys(this.state.formData).forEach(key => {
            if(formData[key] !== undefined && formData[key] !== null && formData[key] !== '') {
                stockItemFormData.append(key,formData[key]);
            }
        });

        try {
            const response = await apiCall(`business/stock/item/update/${id}`,'post',stockItemFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.props.history.push('/stock/items');
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, isLoad, parentCategories, subCategories, selectedParentId, formData, warehouseStocks, warehouses, stockItem, isQuickStockModalOpen, quickStockMovementType} = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div className="page-loader-wrapper" style={{display: isLoad ? 'block' : 'none'}}>
                    <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div className="m-t-30">
                            <img src={require('../../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                        </div>
                        <p>Yükleniyor</p>
                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                    </div>
                </div>
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Stok Kalemi Detay"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Stok Kalemleri", navigate: "stock/items" },
                                { name: "Stok Kalemi Detay", navigate: "" },
                            ]}
                        />

                        {/* Hızlı Stok Kartı */}
                        <QuickStockCard
                            stockItem={stockItem}
                            warehouseStocks={warehouseStocks}
                            onAddStock={() => this.openQuickStockModal('purchase')}
                            onRemoveStock={() => this.openQuickStockModal('sale')}
                        />

                        {/* Depo Detayları - Card Görünümü */}
                        <div className="row clearfix mb-4">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Depo Detayları</h2>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            {warehouseStocks.length > 0 ? warehouseStocks.map(ws => (
                                                <div key={ws.id} className="col-md-4 col-sm-6 mb-3">
                                                    <div className="card" style={{
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                        border: 'none',
                                                        borderTop: '4px solid #17a2b8',
                                                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                                    }}>
                                                        <div className="body">
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <div style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    borderRadius: '10px',
                                                                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>
                                                                    <i className="icon-drawer" style={{fontSize: '20px', color: 'white'}}></i>
                                                                </div>
                                                                <h6 className="mb-0" style={{
                                                                    color: '#17a2b8',
                                                                    fontWeight: '700',
                                                                    fontSize: '14px',
                                                                    flex: 1,
                                                                    marginLeft: '12px'
                                                                }}>
                                                                    {ws.warehouse ? ws.warehouse.name : 'Bilinmeyen Depo'}
                                                                </h6>
                                                            </div>
                                                            
                                                            <h2 className="mb-0 text-center" style={{
                                                                color: '#17a2b8',
                                                                fontWeight: '700',
                                                                fontSize: '42px'
                                                            }}>
                                                                {Math.round(parseFloat(ws.quantity || 0))}
                                                            </h2>
                                                            <p className="text-center text-muted mb-3" style={{fontSize: '14px'}}>toplam adet</p>
                                                            
                                                            <div style={{
                                                                padding: '10px',
                                                                borderRadius: '8px',
                                                                background: 'white'
                                                            }}>
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <small style={{color: '#6c757d', fontSize: '12px'}}>
                                                                        <i className="icon-check" style={{color: '#28a745'}}></i> Kullanılabilir
                                                                    </small>
                                                                    <strong style={{color: '#28a745', fontSize: '16px'}}>
                                                                        {Math.round(parseFloat(ws.available_quantity || 0))}
                                                                    </strong>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <small style={{color: '#6c757d', fontSize: '12px'}}>
                                                                        <i className="icon-lock" style={{color: '#ffc107'}}></i> Rezerve
                                                                    </small>
                                                                    <strong style={{color: '#ffc107', fontSize: '16px'}}>
                                                                        {Math.round(parseFloat(ws.reserved_quantity || 0))}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                            
                                                            {ws.last_updated && (
                                                                <div className="mt-3 text-center">
                                                                    <small style={{
                                                                        color: '#6c757d',
                                                                        fontSize: '11px',
                                                                        padding: '4px 10px',
                                                                        background: 'white',
                                                                        borderRadius: '20px'
                                                                    }}>
                                                                        <i className="icon-clock"></i> {new Date(ws.last_updated).toLocaleDateString('tr-TR')}
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div className="col-12">
                                                    <div className="alert alert-info text-center">
                                                        <i className="icon-info" style={{fontSize: '32px', display: 'block', marginBottom: '10px'}}></i>
                                                        <p className="mb-0">Henüz hiçbir depoda stok bulunmuyor</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Form */}
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Stok Kalemi Adı *</label>
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Stok Kalemi Adı"
                                                        type="text"
                                                        value={formData.name}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>SKU</label>
                                                            <input
                                                                id="sku"
                                                                className="form-control"
                                                                placeholder="SKU"
                                                                type="text"
                                                                value={formData.sku}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Barkod</label>
                                                            <input
                                                                id="barcode"
                                                                className="form-control"
                                                                placeholder="Barkod"
                                                                type="text"
                                                                value={formData.barcode}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Ana Kategori *</label>
                                                    <select
                                                        className="form-control"
                                                        value={selectedParentId}
                                                        onChange={this.handleParentCategoryChange}
                                                        required
                                                    >
                                                        <option value="">Ana Kategori Seçin</option>
                                                        {parentCategories.map(category => (
                                                            <option key={category.id} value={category.id}>
                                                                📁 {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Alt Kategori *</label>
                                                    <select
                                                        id="category_id"
                                                        className="form-control"
                                                        value={formData.category_id}
                                                        onChange={this.handleChange}
                                                        disabled={!selectedParentId || subCategories.length === 0}
                                                        required
                                                    >
                                                        <option value="">
                                                            {!selectedParentId ? 'Önce Ana Kategori Seçin' :
                                                             subCategories.length === 0 ? 'Bu kategoride alt kategori yok' :
                                                             'Alt Kategori Seçin'}
                                                        </option>
                                                        {subCategories.map(category => (
                                                            <option key={category.id} value={category.id}>
                                                                📄 {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <small className="form-text text-muted">
                                                        {selectedParentId && subCategories.length === 0 && (
                                                            <span className="text-warning">
                                                                ⚠️ Bu ana kategoride alt kategori bulunmuyor
                                                            </span>
                                                        )}
                                                        {selectedParentId && subCategories.length > 0 && (
                                                            <span className="text-success">
                                                                ✓ {subCategories.length} alt kategori mevcut
                                                            </span>
                                                        )}
                                                    </small>
                                                </div>
                                                <div className="form-group">
                                                    <label>Birim</label>
                                                    <select
                                                        id="unit"
                                                        className="form-control"
                                                        value={formData.unit}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="adet">Adet</option>
                                                        <option value="kg">Kilogram</option>
                                                        <option value="lt">Litre</option>
                                                        <option value="m">Metre</option>
                                                        <option value="m2">Metrekare</option>
                                                        <option value="m3">Metreküp</option>
                                                        <option value="kutu">Kutu</option>
                                                        <option value="paket">Paket</option>
                                                    </select>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Birim Fiyat</label>
                                                            <input
                                                                id="unit_price"
                                                                className="form-control"
                                                                placeholder="0.00"
                                                                type="number"
                                                                step="0.01"
                                                                value={formData.unit_price}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Min. Stok</label>
                                                            <input
                                                                id="min_stock_level"
                                                                className="form-control"
                                                                placeholder="0"
                                                                type="number"
                                                                value={formData.min_stock_level}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Max. Stok</label>
                                                            <input
                                                                id="max_stock_level"
                                                                className="form-control"
                                                                placeholder="0"
                                                                type="number"
                                                                value={formData.max_stock_level}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Açıklama</label>
                                                    <textarea
                                                        id="description"
                                                        className="form-control"
                                                        placeholder="Açıklama"
                                                        rows="3"
                                                        value={formData.description}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="is_serialized"
                                                            checked={formData.is_serialized}
                                                            onChange={this.handleChange}
                                                        />
                                                        <label className="custom-control-label" htmlFor="is_serialized">
                                                            Seri Numarası Takibi
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="is_lot_tracked"
                                                            checked={formData.is_lot_tracked}
                                                            onChange={this.handleChange}
                                                        />
                                                        <label className="custom-control-label" htmlFor="is_lot_tracked">
                                                            Lot/Parti Takibi
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="is_active"
                                                            checked={formData.is_active}
                                                            onChange={this.handleChange}
                                                        />
                                                        <label className="custom-control-label" htmlFor="is_active">
                                                            Aktif
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                <button className="btn btn-outline-primary btn-block" type="submit">
                                                    Güncelle
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hızlı Stok İşlemi Modal */}
                <QuickStockModal
                    isOpen={isQuickStockModalOpen}
                    toggle={this.closeQuickStockModal}
                    stockItem={stockItem}
                    movementType={quickStockMovementType}
                    warehouses={warehouses}
                    onSuccess={this.handleQuickStockSuccess}
                />
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockItemDetail));

